import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=4bc4e75e&scoped=true&"
import script from "./grant.vue?vue&type=script&lang=js&"
export * from "./grant.vue?vue&type=script&lang=js&"
import style0 from "./grant.vue?vue&type=style&index=0&id=4bc4e75e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4e75e",
  null
  
)

export default component.exports